import React from 'react';

/** Thumb-reach navigation for phones; hidden from tablets upwards. */
export const BottomNav = ({ items, active, onSelect }) => (
  <nav data-testid="mobile-bottom-nav"
    className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur md:hidden"
    style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
    <div className="mx-auto flex max-w-lg">
      {items.map(({ id, label, icon: Icon, badge, onClick }) => {
        const current = active === id;
        return (
          <button key={id} type="button" aria-label={label} aria-current={current ? 'page' : undefined}
            data-testid={`mobile-nav-${id}`}
            onClick={() => (onClick ? onClick() : onSelect(id))}
            className={`relative flex flex-1 flex-col items-center gap-0.5 px-1 py-2.5 text-[10px] font-medium transition-colors ${current ? 'text-[#0F4C81]' : 'text-slate-500'}`}>
            <span className={`flex h-7 w-12 items-center justify-center rounded-full transition-colors ${current ? 'bg-[#0F4C81]/10' : ''}`}>
              <Icon className="h-[18px] w-[18px]" strokeWidth={1.8} />
            </span>
            <span className="truncate">{label}</span>
            {badge > 0 && (
              <span className="absolute right-[18%] top-1 min-w-[16px] rounded-full bg-[#10B981] px-1 text-[9px] font-semibold leading-4 text-white">
                {badge > 9 ? '9+' : badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  </nav>
);
